import { IUserSessionContext } from "./user-session-context-provider";
import { LocaleType } from "../../../constants/constants";
import i18next from "i18next";
import { User } from "../../../context/user";
import { Profile } from "../../model/profile";
import { DefaultLanguageProvider } from "./default-language-provider";

interface IUserSessionContextDispatcherChangeLocalePayload {
    action: "change-locale";
    locale: LocaleType;
}

interface IUserSessionContextDispatcherAuthenticateUserPayload {
    action: "authenticate-user";
    user: User;
    profile: Profile;
}

export type IUserSessionContextDispatcherPayload = IUserSessionContextDispatcherAuthenticateUserPayload
    | IUserSessionContextDispatcherChangeLocalePayload;

export const UserSessionContextReducer = (ctx: IUserSessionContext,
                                          message: IUserSessionContextDispatcherPayload) => {
    switch (message.action) {
        case "authenticate-user":
            const targetLanguage = message.profile.lang || i18next.language || new DefaultLanguageProvider().get();
            if (i18next.language !== targetLanguage) {
                i18next.changeLanguage(message.profile.lang);
            }

            return {
                ...ctx,
                user: message.user,
                locale: targetLanguage as LocaleType,
            };
        case "change-locale":
            i18next.changeLanguage(message.locale);

            return {
                ...ctx,
                locale: message.locale,
            };
        default:
            throw new Error("Unsupported action");
    }
};
